export const predefinedStyles = [
  {
    id: 1,
    name: "Modern Minimal",
    description: "Clean and contemporary",
    font: "Inter, sans-serif",
    background: { name: "Pure White", type: "color", value: "#ffffff" },
    textColor: "#1f2937",
    textAlign: "center",
    fontSize: 28,
    typographyType: 'dynamic'
  },
  {
    id: 21,
    name: "Neo-Brutalism",
    description: "Bold, high-contrast design",
    font: "Anton, sans-serif",
    background: { name: "Vibrant Orange", type: "color", value: "#f97316" },
    textColor: "#000000",
    textAlign: "left",
    fontSize: 34,
    typographyType: 'brutal',
    accentColor: '#FFDC00'
  },
  {
    id: 22,
    name: "Minimal Polaroid",
    description: "Elegant gallery signature",
    font: "Playfair Display, serif",
    background: { name: "Deep Black", type: "color", value: "#1a1a1a" },
    textColor: "#ffffff",
    textAlign: "center",
    fontSize: 24,
    typographyType: 'polaroid',
    accentColor: '#38bdf8'
  },
  {
    id: 19,
    name: "Editorial",
    description: "High-end magazine aesthetic",
    font: "Playfair Display, serif",
    background: { name: "Paper Texture", type: "image", value: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800" },
    textColor: "#1a1a1a",
    textAlign: "left",
    fontSize: 26,
    typographyType: 'magazine',
    accentColor: '#000000'
  },
  {
    id: 20,
    name: "Digital Glitch",
    description: "Cyberpunk scanner look",
    font: "Righteous, cursive",
    background: { name: "Deep Black", type: "color", value: "#000000" },
    textColor: "#ffffff",
    textAlign: "center",
    fontSize: 30,
    typographyType: 'retro',
    accentColor: '#00ffff'
  },
  {
    id: 16,
    name: "Frosted Glass",
    description: "Elegant glassmorphism",
    font: "Montserrat, sans-serif",
    background: { name: "Ocean Soft", type: "gradient", value: "linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%)" },
    textColor: "#0369a1",
    textAlign: "center",
    fontSize: 24,
    typographyType: 'glass',
    accentColor: '#38bdf8'
  },
  {
    id: 18,
    name: "Pop Sticker",
    description: "Bold comic-book style",
    font: "Righteous, cursive",
    background: { name: "Vibrant Orange", type: "color", value: "#f97316" },
    textColor: "#000000",
    textAlign: "center",
    fontSize: 34,
    typographyType: 'sticker',
    accentColor: '#ef4444'
  }
];